import React from 'react';
import Script from 'next/script';
import { jsx as _jsx } from "react/jsx-runtime";
const BranchLoader = _ref => {
  let {
    branchKey,
    title,
    description,
    imageUrl,
    offerId,
    centreSlug
  } = _ref;
  if (!branchKey) {
    return null;
  }
  return /*#__PURE__*/_jsx(Script, {
    id: "load-and-initialize-branch",
    dangerouslySetInnerHTML: {
      __html: "// load Branch\n        let branchKey = '".concat(branchKey, "';\n        if (branchKey.length > 0) {\n          (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src=\"https://cdn.branch.io/branch-latest.min.js\";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,\"script\",\"branch\",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},\"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking qrCode\".split(\" \"), 0);\n          branch.init(branchKey, function (err, data) {\n            branch.setBranchViewData({\n              data: {\n                title: \"").concat(title, "\",\n                description: \"").concat(description, "\",\n                image: \"").concat(imageUrl, "\",\n                offerId: \"").concat(offerId, "\",\n                centreSlug: \"").concat(centreSlug, "\"\n              }\n            })\n          });\n        }")
    },
    "data-id": "branch-loader_index_BranchLoader_Script"
  });
};
export default BranchLoader;